export const checkHighAndThick = (totalItems: number, current: number) => {
  if (totalItems < 3) return null;

  const isLast = current === totalItems;

  const lastSpecialPosition = 3 + Math.floor((totalItems - 3) / 5) * 5;

  return lastSpecialPosition === totalItems && isLast
    ? lastSpecialPosition
    : null;
};

export const checkBeforeHighAndThick = (
  highAndThickPosition: number | null,
  current: number
) => highAndThickPosition !== null && current === highAndThickPosition - 1;
